import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import Routes from '../../components/App/Routes';

const mapStateToProps = state => ({ user: state.user });
export default withRouter(connect(mapStateToProps, {})(Routes));